export interface CuratedList {
  id: number;
  title: string;
  tagline: string;
  cover: string;
  itemCount: number;
  description: string;
  tags: string[];
}

export const curatedLists: CuratedList[] = [
  {
    id: 1,
    title: "周末宅家必刷：治愈系片单",
    tagline: "给疲惫的一周按个暂停键",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20weekend%20movie%20night%20scene%20with%20warm%20blankets%2C%20popcorn%2C%20soft%20string%20lights%20and%20a%20glowing%20screen%2C%20warm%20cream%20and%20amber%20lighting%2C%20relaxing%20homely%20atmosphere%2C%20cinematic%20photography%20style%20illustration&width=720&height=460&seq=list-cozy-2231&orientation=landscape",
    itemCount: 10,
    description: "节奏舒缓、情绪治愈的电影合集。无论生活多忙，关上灯窝进沙发，一部好片就是最好的充电。",
    tags: ["治愈", "剧情", "轻松"],
  },
  {
    id: 2,
    title: "硬核科幻迷清单：想象力天花板",
    tagline: "用一整个周末遨游宇宙",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20galaxy%20landscape%20with%20a%20lone%20astronaut%20floating%20before%20a%20giant%20nebula%20and%20distant%20starship%2C%20deep%20space%20with%20warm%20gold%20and%20crimson%20accent%20lights%2C%20awe%20inspiring%20cinematic%20illustration%2C%20high%20detail&width=720&height=460&seq=list-scifi-7754&orientation=landscape",
    itemCount: 8,
    description: "从时间旅行到星际移民，从意识上传到宇宙尺度的抉择。一份让想象力不断越界的硬核片单。",
    tags: ["科幻", "太空", "烧脑"],
  },
  {
    id: 3,
    title: "高分剧情片：那些值得二刷的故事",
    tagline: "好的故事，值得反复回味",
    cover: "https://readdy.ai/api/search-image?query=Moody%20dramatic%20cinema%20scene%20with%20an%20empty%20red%20theater%20seat%20facing%20a%20projector%20beam%20in%20a%20dark%20room%2C%20warm%20amber%20glow%20through%20dust%2C%20introspective%20emotional%20atmosphere%2C%20cinematic%20film%20noir%20illustration&width=720&height=460&seq=list-drama-8866&orientation=landscape",
    itemCount: 12,
    description: "真正的佳作经得起反复观看。每一次重看，都会在细节里发现藏在表层之下的另一层情绪。",
    tags: ["剧情", "人生", "回味"],
  },
  {
    id: 4,
    title: "笑出腹肌：快乐源泉大合集",
    tagline: "不开心？看喜剧就对了",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20joyful%20comedy%20film%20poster%20wall%20collage%20with%20confetti%2C%20bright%20balloons%20and%20popcorn%2C%20playful%20warm%20orange%20and%20pink%20tones%2C%20fun%20lighthearted%20energetic%20atmosphere%2C%20cinematic%20illustration&width=720&height=460&seq=list-comedy-9922&orientation=landscape",
    itemCount: 9,
    description: "专治各种不开心。汇集喜剧与轻喜剧佳作，笑点密集、解压满分，适合全家人一起看。",
    tags: ["喜剧", "解压", "合家欢"],
  },
];

export interface EditorialItem {
  id: number;
  title: string;
  summary: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
}

export const editorials: EditorialItem[] = [
  {
    id: 1,
    title: "2026 秋季院线前瞻：这十部电影值得提前锁票",
    summary: "从科幻大片到现实主义文艺片，新一季的银幕热闹非凡。我们替你梳理了最值得关注的十部新片与上映档期。",
    category: "院线前瞻",
    date: "2026-09-02",
    readTime: "6 分钟阅读",
    image: "https://readdy.ai/api/search-image?query=Autumn%20cinema%20preview%20concept%20with%20warm%20fall%20maple%20leaves%20and%20film%20reel%20over%20a%20glowing%20marquee%2C%20warm%20orange%20and%20crimson%20tones%2C%20cinematic%20magazine%20editorial%20style%2C%20artistic%20illustration&width=720&height=460&seq=ed-autumn-3301&orientation=landscape",
  },
  {
    id: 2,
    title: "从预告片到正片：解读新一代国产科幻的工业美学",
    summary: "当“想象力”遇上成熟的制作工业，国产科幻正在完成从追赶到并跑的关键一跃。本文拆解其视觉与叙事语言。",
    category: "影评深读",
    date: "2026-08-28",
    readTime: "8 分钟阅读",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20film%20concept%20art%20with%20gleaming%20space%20colony%20and%20reflective%20architecture%20at%20dusk%2C%20warm%20gold%20and%20cool%20contrast%2C%20cinematic%20editorial%20illustration%2C%20high%20detail&width=720&height=460&seq=ed-scifi-8812&orientation=landscape",
  },
  {
    id: 3,
    title: "家庭观影怎么选？一份按年龄挑选的合家欢片单",
    summary: "周末想和家人一起看场电影？按年龄段与题材整理了安全、有趣又能引发讨论的亲子观影选择。",
    category: "观影指南",
    date: "2026-08-20",
    readTime: "5 分钟阅读",
    image: "https://readdy.ai/api/search-image?query=Warm%20family%20movie%20night%20at%20home%20with%20parents%20and%20children%20watching%20on%20sofa%20with%20blankets%20and%20snacks%2C%20cozy%20warm%20amber%20lighting%2C%20heartwarming%20cinematic%20illustration&width=720&height=460&seq=ed-family-5520&orientation=landscape",
  },
  {
    id: 4,
    title: "那些被低估的冷门佳片：榜单之外也有好风景",
    summary: "热门榜单之外，还有一批安静却闪光的电影。它们可能排片少、话题少，却值得被更多人看见。",
    category: "冷门拾遗",
    date: "2026-08-12",
    readTime: "7 分钟阅读",
    image: "https://readdy.ai/api/search-image?query=Quiet%20artsy%20indie%20film%20concept%20with%20vintage%20film%20projector%20and%20dusty%20light%20beams%20in%20a%20cozy%20theater%2C%20muted%20warm%20sepia%20tones%2C%20contemplative%20editorial%20illustration&width=720&height=460&seq=ed-underseen-7743&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "吃瓜影院是什么网站？能做什么？",
    a: "吃瓜影院是一个面向影迷的电影选片与观影指南网站。我们持续整理最新电影资讯、编辑精选片单、口碑评分与专业影评，并按题材、年份、区域帮你快速定位想看的影片，解决“想看好电影却不知从何找起”的难题。",
  },
  {
    q: "网站上的片库和评分是怎么来的？",
    a: "片库由编辑部人工筛选并结合主流平台的热度与口碑整理而成，评分为吃瓜影院站内综合评价，综合了专业媒体与大众观众的评价倾向，仅作为选片参考，不代表权威评分机构结论。",
  },
  {
    q: "我想观看影片，应该去哪里看？",
    a: "受版权与发行规则限制，吃瓜影院不提供任何影片下载或盗版在线观看渠道。请通过正规视频平台、影院上映或官方授权渠道进行观影，以尊重创作者的劳动成果。",
  },
  {
    q: "网站多久更新一次？新片资讯及时吗？",
    a: "编辑部保持高频更新，院线档期、新片预告、热议电影等资讯通常会在发布后的第一时间整理上线，精选片单也会结合季节与热点定期刷新。",
  },
  {
    q: "我可以投稿自己的影评或推荐片单吗？",
    a: "当然可以。我们欢迎影迷分享真实的观影体验。你可以在“联系我们”板块留言投稿，优质内容经编辑部审核后会署名发布在专栏中。",
  },
  {
    q: "如何反馈片库中的错误信息或提出需求？",
    a: "如果你发现影片信息有误，或希望我们补充某个题材、某个片单方向，欢迎通过站内联系邮箱反馈。我们会认真核对并及时修正。",
  },
];